const KEY = "postLoginRedirectDealerOMG"

/** Remembers the protected page the user asked for, so login can bring them back to it. */
export const rememberPostLoginPath = (location) => {
  const path = `${location.pathname}${location.search}`
  if (path && path !== "/" && path !== "/login") {
    sessionStorage.setItem(KEY, path)
  }
}

/** Returns the remembered in-app path once (then forgets it), or "/" if there is none. */
export const takePostLoginPath = () => {
  const path = sessionStorage.getItem(KEY)
  sessionStorage.removeItem(KEY)
  // Only same-origin app paths: "//host" or absolute URLs would be an open redirect.
  return path && path.startsWith("/") && !path.startsWith("//") ? path : "/"
}
